import { BehaviorSubject, first, switchMap, tap } from 'rxjs';
// @TODO: create this as a class, so the repositoryfactory can be injected
class PublicCredentials {
  constructor() {
    this.legacyAuthCredentials$ = new BehaviorSubject({});
    this.setNewCredentials = credentials => {
      this.legacyAuthCredentials$.next(credentials);
    };
    this.getPublicStoreCredentials = authRepository => {
      return this.legacyAuthCredentials$.pipe(first(), switchMap(credentials => {
        if (!credentials.accessToken) {
          return authRepository.findByStore().pipe(tap(response => this.legacyAuthCredentials$.next(response)));
        }
        return this.legacyAuthCredentials$.asObservable();
      }));
    };
  }
}
export const publicCredentials = new PublicCredentials();
